module.exports = __webpack_public_path__ + "fonts/NotoSans-Italic.6c593a09.woff";